import React from 'react';
import { message } from 'antd';
import PageErrorTemplate from "./PageErrorTemplate";
import { apps } from '../commonConfig.json'

class QMSErrorHandle extends React.Component {
    constructor(props) {
        super(props);
        this.props = props;
        this.state = {errResponse : ""};
        this.errorHandleFunc = this.errorHandleFunc.bind(this);
        this.sessionHandleFunc = this.sessionHandleFunc.bind(this);
    }

    sessionHandleFunc() {
            if (this.props.errordetails.app !== undefined && 
                this.props.errordetails.app === apps.COMPLIANCE) { //compliance
                    let pmsSessionComp = JSON.parse(sessionStorage.getItem("compParams"));
                    delete pmsSessionComp.pms;
                    sessionStorage.setItem('compParams',JSON.stringify(pmsSessionComp));
            } else { //QMS
                sessionStorage.removeItem('pms');
            }
    }

    errorHandleFunc() {
        if (this.props.errordetails.display === true) {
            if (this.props.errordetails.err === true) {
                if (this.props.errordetails.errType === 'pageErr') {
                    if (this.props.errordetails.errCode === '404') {
                        document.title = "404 Page Not Found";
                        this.setState({
                            errResponse : <PageErrorTemplate errorType='404' />
                        })
                    } else if (this.props.errordetails.errCode === '403') {
                        if (this.props.errordetails.errMsg === "Invalid PMS") {
                            this.setState({
                                errResponse : <PageErrorTemplate errorType='403'  additionalBtnActions={() => this.sessionHandleFunc()} />
                            })
                        } else {
                            this.setState({
                                errResponse : <PageErrorTemplate errorType='403'/>
                            })
                        }
                    } else {
                            // this.setState({
                            //     errResponse : (<Result
                            //                     status={this.props.errordetails.errCode}
                            //                     title={this.props.errordetails.errCode}
                            //                     subTitle={this.props.errordetails.errMsg}
                            //                 />)
                            // })
                            this.setState({
                                errResponse : <PageErrorTemplate errorType='500' additionalErrorMsg={this.props.errordetails.errMsg} />
                            })
                    }
                } else {
                    (this.props.errordetails.errCode === 'Warning' ?
                        message.warning(this.props.errordetails.errMsg) :
                        message.error(this.props.errordetails.errMsg)
                    )
                }
            } else {
                message.success(this.props.errordetails.errMsg)
            }
        }
        return;
    }

    componentDidUpdate(prevProp) {
        if(prevProp.errordetails.display !== this.props.errordetails.display){
            this.errorHandleFunc();
        }
    }
    componentDidMount(){
        this.errorHandleFunc();
    }
    render() {
        return (this.state.errResponse);
    }
}

export default QMSErrorHandle;